// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import Audit from '@deere/cps-it.warranty-model-factory/lib/audit';
import {FormattedMessage} from 'react-intl';

const queryString = accounts =>
    accounts.join('&d=');

const PrepareRecordButtonGroup = props =>
    <section className='button-group'>
        {props.audit.isSkipAuditAllowed &&
            <button
                className='secondary'
                onClick={() => props.updateSkipAudit(props.audit)}
            >
                <FormattedMessage id='SKIP_AUDIT'/>
            </button>
        }
        <a
            className={props.audit.isAuditPrepared ? 'secondary' : 'primary'}
            href={props.audit.isAuditPrepared ?
                `#/tcsm/audits/prepare?auditNumber=${props.audit.auditNumber}&d=${queryString(props.audit.accounts)}` :
                `#/tcsm/audits/prepare?d=${queryString(props.audit.accounts)}`}
        >
            <FormattedMessage id='PREPARE_AUDIT'/>
        </a>
        {props.audit.isAuditPrepared &&
            <a
                className='primary'
                href={`#/tcsm/audits/record?auditNumber=${props.audit.auditNumber}`}
            >
                <FormattedMessage id='RECORD_AUDIT'/>
            </a>
        }
    </section>;

PrepareRecordButtonGroup.displayName = 'PrepareRecordButtonGroup';
PrepareRecordButtonGroup.propTypes = {
    audit: PropTypes.instanceOf(Audit).isRequired,
    updateSkipAudit: PropTypes.func.isRequired
};

export default PrepareRecordButtonGroup;



// WEBPACK FOOTER //
// ./src/tcsm/audits/components/audit-list/prepare-record-button-group.js